import { render, staticRenderFns } from "./OurFaq.vue?vue&type=template&id=4abaf2ec&scoped=true&"
import script from "./OurFaq.vue?vue&type=script&lang=js&"
export * from "./OurFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abaf2ec",
  null
  
)

export default component.exports